<template>
  <div>
    <el-card shadow="never" style="padding-bottom: 15px">
      <el-col style="padding-top: 5pt">
        <span class="head-title">Generate Reports For Other Benefits ( {{ aStatusLabel }} )</span>
      </el-col>
    </el-card>
    <el-row :gutter="5" >
      <el-col :xs="12" :sm="12" :md="24" :lg="24">
        <el-card v-loading = "loading1" class="box-card">
          <div slot="header" class="clearfix">
            <span>Post Other Benefits Ledger</span>
          </div>
          <div style="font-size: 12px; margin-left: 40px;margin-bottom: 10px">Note: Personnel data is optional and may be left blank if not applicable.</div>
          <el-form v-loading="loading" :inline="true" label-width="80px" class="demo-form-inline">
            <el-form-item label="Year">
              <el-select v-model="year" placeholder="Year" @change="getAll">
                <el-option v-for="thisyear in (currentYear)" v-if="thisyear >= startYear" :key="thisyear" :value="thisyear" :label="thisyear" />
              </el-select>
            </el-form-item>
            <el-form-item label="Month">
              <el-select v-model="month" placeholder="Month" @change="getAll">
                <el-option v-for="(thismonth, index) in monthList" :key="index" :label="thismonth" :value="index + 1"/>
              </el-select>
            </el-form-item>
            <el-form-item label="Benefits">
              <select-benefits :disable="benefitdisable" :type="type" :benef="benefit" :key="sel" @setBenefit="setBenefits(benefit_id = $event)"/>
            </el-form-item>
            <el-form-item label="Personnel">
              <el-select v-model="personnel_id" multiple filterable clearable placeholder="(Optional..)">
                <el-option
                  v-for="item in personnelList"
                  :key="item.id"
                  :label="item.fullname"
                  :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="create">Post</el-button>
            </el-form-item>
          </el-form>
          <el-alert
            :closable="false"
            title="Info"
            type="info"
            description="This panel generate other benefit ledger."
            show-icon />
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="13">
        <el-card class="box-card">
          <span class="head-title">List of other benefit Ledger for the month of {{ monthList[(month - 1)] }} {{ year }}</span>
          <el-table
            v-loading="loading"
            :data="report"
            :key="keys"
            element-loading-text="Loading..."
            style="width: 100%;margin-top: 20px">
            <!--el-table-column
              prop="year"
              label="Year"
              width="70em"/>
            <el-table-column
              prop="month"
              label="Month"
              width="100em">
              <template slot-scope="scope">
                {{ monthList[(scope.row.month - 1)] }}
              </template>
            </el-table-column-->
            <el-table-column
              label="Benefits">
              <template slot-scope="scope">
                <div v-if="scope.row.ledger">{{ scope.row.ledger.ref_benefit.name }}</div>
              </template>
            </el-table-column>
            <el-table-column label="Payroll" align="center">
              <template slot-scope="scope">
                <el-button type="success" round size="small" @click="download('other','whole', scope.row )"><i class="el-icon-download"/></el-button>
              </template>
            </el-table-column>
            <el-table-column label="Indexes" width="80px">
              <template slot-scope="scope">
                <el-button :disabled="(scope.row.index===0)?true:false" type="default" round size="small" @click="indexes('index','whole', scope.row )"><i class="far fa-file-excel" size="7x"/></el-button>
              </template>
            </el-table-column>
            <el-table-column label="Repost" align="center">
              <template slot-scope="scope">
                <el-button :disabled="(scope.row.index===0)?true:false" type="success" round size="small" @click="repost(scope.row)"><i class="far fa-edit"/></el-button>
              </template>
            </el-table-column>
            <el-table-column label="Fund Source" align="center">
              <template slot-scope="scope">
                <el-button :disabled="(scope.row.index===0)?true:false" type="success" round size="small" @click="generateTotalFundSource('fundSource', scope.row )" ><i class="far fa-file" size="7x"/></el-button>
              </template>
            </el-table-column>
            <el-table-column label="Remittance" align="center">
              <template slot-scope="scope">
                <el-button :disabled="(scope.row.index===0)?true:false" type="success" round size="small" @click="remittance(scope.row )" ><i class="far fa-file" size="7x"/></el-button>
              </template>
            </el-table-column>
            <el-table-column label="Details" width="120px" align="center">
              <template slot-scope="scope">
                <el-button type="success" round size="small" @click="getAllPersonnelWithBenefits(scope.row)"><i class="far fa-eye"/></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
          </div>
        </el-card>
      </el-col>
      <el-col v-if="showDetails" :md="11">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="head-title">List of Personnel with <span style="color: black">{{ title }}</span></span>
            <el-button type="primary" icon="el-icon-refresh" size="small" style="float: right;margin-left: 10px" @click="refreshData(sBenefitID)"> Refresh </el-button>
          </div>
          <div style="float: right;">
            <el-input v-model="term" placeholder="Search here ......">
              <el-button slot="append" icon="el-icon-search" @click="getAllPersonnelWithBenefits(sBenefitID)" />
            </el-input>
          </div>
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            size="small"
            style="width: 100%; margin-top: 20px">
            <el-table-column label="Personnel">
              <template slot-scope="scope">
                {{ scope.row.lastname + ', ' + scope.row.firstname + ' ' }} {{ scope.row.middlename || scope.row.middlename === '' ? scope.row.middlename + '.' : '' }}
              </template>
            </el-table-column>
            <el-table-column label="Amount">
              <template slot-scope="scope">
                {{ Number(scope.row.amount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
            </el-table-column>
            <el-table-column label="Status">
              <template slot-scope="scope">
                <span v-if="scope.row.status > 0" style="color: #0a8700">Active</span>
                <span v-else style="color: red">In active</span>
              </template>
            </el-table-column>
            <el-table-column label="" width="220px">
              <template slot-scope="scope">
                <el-button v-if="IsRepost" type="success" round size="small" @click="showEditAmountDialog(scope.row)"><i class="el-icon-edit" size="9px"/></el-button>
                <el-button type="danger" round size="small" @click="exIncludePersonnel(scope.row)"><i class="el-icon-circle-close" size="9px"/></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta0.per_page" :pager-count="11" :total="meta0.total" :current-page.sync="meta0.page" layout="total, prev, pager, next" @current-change="getAllPersonnelWithBenefits(sBenefitID)"/>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="showEditAmount"
      :before-close="closeEditAmount"
      title="Edit Amount"
      width="20%">
      <el-input v-model="editamount" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEditAmount">Cancel</el-button>
        <el-button type="primary" @click="saveEditAmount">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="showGenerateRemittance"
      title="Generate Remittance"
      width="20%">
      <el-select v-model="deduction_id" filterable clearable placeholder="Select Benefits">
        <el-option v-for="deduction in deductions" :key="deduction.id" :value="deduction.id" :label="deduction.desc">{{ deduction.desc }}</el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="generateRemittance">Generate</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="title"
      width="60%">
      <div>
        <el-table
          :data="fundSourceTable"
          :summary-method="getSummaries"
          show-summary
          style="width: 100%">
          <el-table-column
            prop="fundType"
            label="Fund source"/>
          <el-table-column
            prop="cntPersonnel"
            label="# of Personnel"/>
          <el-table-column
            prop="baseamount"
            label="Basic Amount">
            <template slot-scope="scope">
              {{ Number(scope.row.baseamount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="cashGift"
            label="Cash Gift">
            <template slot-scope="scope">
              {{ Number(scope.row.cashGift).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="amount"
            label="Gross Amount">
            <template slot-scope="scope">
              {{ Number(scope.row.amount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SelectBenefits from '@/views/layout/components/SelectBenefits'
import { EmpBenefits } from '@/api/payroll/empbenefits'
import { Personnel } from '@/api/payroll/personnel'
import { getToken } from '@/utils/auth'
import { NotifyError, NotifySuccess } from '../../../helper/Helper'
import { Deduction } from '../../../api/payroll/deduction'
// import { Report } from '../../../api/payroll/report'
// import { NotifySuccess } from '@/helper/Helper'
export default {
  name: 'ReportOthers',
  components: { SelectBenefits },
  data() {
    return {
      deduction_id: null,
      showGenerateRemittance: false,
      fundSourceTable: [],
      amountTotal: null,
      dialogVisible: false,
      showEditAmount: false,
      term: null,
      title: null,
      keys: 0,
      meta: {
        page: 1
      },
      benefitdisable: false,
      type: 'report',
      benefit: {},
      sel: 0,
      monthList: [
        'JANUARY',
        'FEBRUARY',
        'MARCH',
        'APRIL',
        'MAY',
        'JUNE',
        'JULY',
        'AUGUST',
        'SEPTEMBER',
        'OCTOBER',
        'NOVEMBER',
        'DECEMBER'
      ],
      report: [],
      loading1: false,
      loading: false,
      benefit_id: null,
      sBenefitID: null,
      meta0: {
        page: 1
      },
      tableData: [],
      tableLoading: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      currentYear: '',
      startYear: 2019,
      showDetails: false,
      existLedger: false,
      personnelList: [],
      personnel_id: null,
      IsRepost: false,
      editAmountID: null,
      editamount: '',
      base_url: this.$store.getters.base_url,
      deductions: [],
      remitDetails: null,
      tenure: parseInt(this.$store.getters.APStatus),
      aStatusLabel: null,
      astatus: parseInt(this.$store.getters.APStatus) === 3 ? 'Permanent' : 'casCon',
      campus_id: this.$store.getters.user.currentUser.personnel.department.campus_id
    }
  },
  created() {
    this.$store.dispatch('APStatus', this.$store.getters.APStatus)
    if (this.tenure === 3) { this.aStatusLabel = 'Permanent' }
    if (this.tenure === 2) { this.aStatusLabel = 'Contractual' }
    if (this.tenure === 1) { this.aStatusLabel = 'Casual' }
    this.getCurrentYear()
    this.getAll()
    this.getPersonnel()
  },
  methods: {
    remittance(row) {
      this.deduction_id = null
      this.remitDetails = row
      this.getDeductionList()
      this.showGenerateRemittance = true
    },
    getDeductionList() {
      Deduction({ per_page: 9999, notsettings: true }, 'get').then(res => {
        this.deductions = res.data.deduction
      }).catch(() => {})
    },
    closeEditAmount() {
      this.showEditAmount = false
      this.editAmountID = null
      this.editamount = ''
    },
    showEditAmountDialog(row) {
      this.showEditAmount = true
      this.editAmountID = row.obid
      this.editamount = row.amount
    },
    saveEditAmount() {
      EmpBenefits({ year: this.sBenefitID.year, month: this.sBenefitID.month, bid: this.editAmountID, amount: this.editamount }, 'post', 'editAmountBenefits').then(res => {
        if (res.data.status === 'success') {
          NotifySuccess('Amount successfully updated')
        } else {
          NotifySuccess('Something is wrong.')
        }
        this.closeEditAmount()
        this.getAll()
        this.getAllPersonnelWithBenefits(this.sBenefitID)
      }).catch(error => {
        console.log(error)
      })
    },
    getPersonnel() {
      Personnel({ campus_id: this.campus_id, tenure: this.tenure }, 'get', 'getPersonnelList').then(res => {
        this.personnelList = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    repost(row) {
      this.$confirm('Are you sure you need to repost this report?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        EmpBenefits({ year: row.year, month: row.month, benefit_id: row.ledger.benefit_id, cnt: row.counter, tenure: this.tenure }, 'post', 'repost').then(res => {
          if (res.data.message === 'success') {
            this.IsRepost = true
            this.getAllPersonnelWithBenefits(row)
            NotifySuccess('Data successfully repost')
          } else {
            NotifySuccess('No data found')
          }
          this.getAll()
        }).catch(error => {
          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    getCurrentYear() {
      this.currentYear = new Date().getFullYear()
    },
    setBenefits(id) {
      this.existLedger = false
      this.loading1 = true
      this.benefit_id = id
      EmpBenefits({ year: this.year, month: this.month, obid: id }, 'post', 'checkifledgerExist').then(res => {
        if (res.data) {
          this.existLedger = res.data.tag === 1
        } else {
          this.existLedger = false
        }
        // console.log(res.data)
        this.loading1 = false
      }).catch(error => {
        console.log(error)
        this.loading1 = false
      })
    },
    create() {
      this.loading = true
      this.showDetails = false
      EmpBenefits({ year: this.year, month: this.month, obid: this.benefit_id, personnel: this.personnel_id, tenure: this.tenure, campus_id: this.campus_id }, 'post', 'createOtherBenefitPosting').then(res => {
        if (res.data.status === 'error') {
          NotifyError(res.data.message)
        } else {
          NotifySuccess(res.data.message)
        }
        this.getAll()
        // this.benefit_id = ''
        // this.personnel_id = []
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    getAll() {
      this.loading = true
      EmpBenefits({ page: this.meta.page, month: this.month, year: this.year, tenure: this.tenure, campus_id: this.campus_id }, 'get', 'getSummaryLedgerMonth').then(res => {
        if (res.data.success === false) {
          this.report = []
          NotifyError(res.data.message)
        } else {
          this.report = res.data.SummaryLedger
          this.meta = res.data.meta
        }
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    refreshData() {
      this.term = null
      this.getAllPersonnelWithBenefits(this.sBenefitID)
    },
    getAllPersonnelWithBenefits(row) {
      this.showDetails = true
      this.sBenefitID = row
      this.title = row.ledger.ref_benefit.name
      this.tableLoading = true
      // EmpBenefits({ page: this.meta0.page, year: row.year, month: row.month, benefit_id: row.ledger.benefit_id, term: this.term }, 'get', 'getAllPersonnelWithBenefits').then(res => {
      EmpBenefits({ page: this.meta0.page, year: row.year, month: row.month, benefit_id: row.ledger.benefit_id, counter: row.counter, term: this.term, astatus: this.astatus, tenure: this.tenure, campus_id: this.campus_id }, 'get', 'getAllPersonnelWithBenefits').then(res => {
        this.tableData = res.data.empbenefits
        this.meta0 = res.data.meta
        this.tableLoading = false
      }).catch(error => {
        console.log(error)
      })
    },
    exIncludePersonnel(row) {
      // console.log(row)
      this.$confirm('Are you sure you want to remove this Personnel?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        EmpBenefits({ year: row.year, month: row.month, benefit_id: row.obid, status: row.status, personnel_id: row.ppPersonnel_id, bid: row.benefit_id, counter: row.counter, tenure: this.tenure }, 'post', 'exIncludePersonnel').then(res => {
          // if (row.status === 1) {
          NotifySuccess('Personnel successfully remove')
          // } else {
          //   NotifySuccess('Personnel successfully added')
          // }
          this.getAll()
          this.getAllPersonnelWithBenefits(this.sBenefitID)
        }).catch(error => {
          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Remove canceled'
        })
      })
    },
    getSummaries(param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total'
        }
        if (index === 1) {
          const number = this.amountTotal.cntPersonnel
          sums[index] = number.toLocaleString('en-US')
        }
        if (index === 2) {
          const number = this.amountTotal.overTotalAmountBase
          sums[index] = number.toLocaleString('en-US')
        }
        if (index === 3) {
          const number = this.amountTotal.overTotalAmountCash
          sums[index] = number.toLocaleString('en-US')
        }
        if (index === 4) {
          const number = this.amountTotal.overTotalAmount
          sums[index] = number.toLocaleString('en-US')
        }
      })
      return sums
    },
    generateTotalFundSource(type, row) {
      this.loading = true
      EmpBenefits({ year: row.year, status: true, astatus: this.astatus, month: row.month, benefit_id: row.ledger.benefit_id, counter: row.counter, tenure: this.tenure, campus_id: this.campus_id, label: 'report' }, 'get', 'TotalAmountPerFundSource').then(res => {
        // console.log(res.data)
        this.fundSourceTable = res.data.list
        this.amountTotal = res.data.total
        this.dialogVisible = true
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    generateRemittance() {
      this.showGenerateRemittance = false
      this.url = this.base_url + '/payroll/report/other/remittance?year=' + this.remitDetails.year + '&astatus=' + this.astatus + '&deduction_id=' + this.deduction_id + '&month=' + this.remitDetails.month + '&campus_id=' + this.campus_id + '&counter=' + this.remitDetails.counter + '&tenure=' + this.tenure + '&token=' + getToken()
      window.open(this.url, '_blank')
    },
    indexes(type, option, row) {
      this.url = this.base_url + '/payroll/report/other?year=' + row.year + '&astatus=' + this.astatus + '&status=' + true + '&month=' + row.month + '&benefit_id=' + row.ledger.benefit_id + '&campus_id=' + this.campus_id + '&counter=' + row.counter + '&tenure=' + this.tenure + '&token=' + getToken() + '&dsk=' + row.id
      window.open(this.url, '_blank')
    },
    download(type, option, row) {
      this.IsRepost = false
      this.showDetails = false
      this.loading = true
      this.infotext = 'Generating Report....'
      EmpBenefits({ year: row.year, status: true, astatus: this.astatus, month: row.month, option: option, type: type, url: row.ledger.url, benefit_id: row.ledger.benefit_id, counter: row.counter, tenure: this.tenure, campus_id: this.campus_id, label: 'report' }, 'get', 'generateReportForOtherBenefit').then(res => {
        this.downlodablefile = res.data.file
        this.getAll()
        this.downloadfile('data:application/pdf;base64, ' + this.downlodablefile)
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    downloadfile(base64URL) {
      var b64 = base64URL
      // if Internet Explorer or Edge
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        var byteCharacters = atob(this.downlodablefile)
        var byteNumbers = new Array(byteCharacters.length)
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        var blob = new Blob([byteArray], { type: 'application/pdf' })
        window.navigator.msSaveOrOpenBlob(blob, 'file-xxx.pdf')
      } else {
        var ww = window.open('about:blank')
        var iframeElem0 = ww.document.createElement('iframe')
        iframeElem0.style = 'position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;'
        setTimeout(function() { // FireFox seems to require a setTimeout for this to work.
          iframeElem0.src = b64
          ww.document.body.appendChild(iframeElem0)
        }, 0)
      }
    }
  }
}
</script>

<style scoped>

</style>
